/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import axios from 'axios';
import { axiosInstance } from '../../queries/axiosInstance';
import { apiRouter, callBackUrl, applicationJson } from '../../constant';
import moment from 'moment';
const apiUrl = apiRouter.APIURL;
const callbackUrl = callBackUrl.url;

export default {
  // Get all

  getData: (url, cancelToken) =>
    new Promise(resolve => {
      let axiosOptions = {};
      if (cancelToken) {
        axiosOptions.cancelToken = cancelToken;
      }
      axiosInstance
        .get(`${apiUrl}/${url}`)
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  getDataWithParameter: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${url}`, {
          params: data,
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  patch: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .patch(`${apiUrl}/${url}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  postData: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .post(`${apiUrl}/${url}?callBackUrl=${callbackUrl}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  postDataNew: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .post(`${apiUrl}/${url}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  postFormData: (url, formData) => {
    return new Promise(resolve => {
      axiosInstance
        .post(`${apiUrl}/${url}`, formData, {
          headers: {
            Accept: applicationJson,
            maxContentLength: '100000000',
            maxBodyLength: '1000000000',
          },
        })
        .then(result => {
          if (!result.status == 200) {
            throw new Error('Network response was not ok');
          }
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    });
  },
  postDataWithParams: (url, params, data) =>
    new Promise(resolve => {
      axiosInstance
        .post(`${apiUrl}/${url}?callBackUrl=${callbackUrl}`, data, {
          params: { ...params },
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  postDataWithQueryParam: (url, params, data) =>
    new Promise(resolve => {
      axiosInstance
        .post(`${apiUrl}/${url}?pkid=${params}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  postDataParams: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .post(`${apiUrl}/${url}/${data}`, null, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  deleteDataParams: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .delete(`${apiUrl}/${url}/${data}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  putData: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .put(`${apiUrl}/${url}?callBackUrl=${callbackUrl}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  putDataWithParams: (url, params) =>
    new Promise(resolve => {
      axiosInstance
        .put(
          `${apiUrl}/${url}?callBackUrl=${callbackUrl}`,
          {},
          {
            params: { ...params },
            headers: {
              'Content-Type': applicationJson,
            },
          },
        )
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  putDataNew: (url, data) =>
    new Promise(resolve => {
      axiosInstance
        .put(`${apiUrl}/${url}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.response?.data.errorMessage ?? err.message);
        });
    }),
  deleteDataWithoutData: URL =>
    new Promise(resolve => {
      axiosInstance
        .delete(`${apiUrl}/${URL}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  deleteData: (URL, data) =>
    new Promise(resolve => {
      axiosInstance
        .delete(`${apiUrl}/${URL}?pkid=${data}`, {
          headers: {
            'Content-Type': applicationJson,
          },
          data,
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  deleteSuperAdmin: (URL, data) =>
    new Promise(resolve => {
      axiosInstance
        .delete(`${apiUrl}/${URL}?pkid=${data}`, {
          headers: {
            'Content-Type': applicationJson,
          },
          data,
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  loginUser: (url, data) =>
    new Promise(resolve => {
      axios
        .post(`${apiUrl}/${url}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          if (err.response.status === 400) {
            err.message = 'Please check the supplied details and try again';
          }
          resolve(err.response?.data?.message ?? err.message);
        });
    }),
  forgotemail: (url, data) =>
    new Promise(resolve => {
      axios
        .post(`${apiUrl}/${url}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  updatePassword: (url, data) =>
    new Promise((resolve, reject) => {
      axios
        .post(`${apiUrl}/${url}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    }),
  resetPassword: (url, data) =>
    new Promise((resolve, reject) => {
      axiosInstance
        .post(`${apiUrl}/${url}`, data, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    }),
  getDataParams: (url, data) =>
    new Promise((resolve, reject) => {
      axiosInstance
        .get(`${apiUrl}/${url}/${data}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    }),
  getDatatwoParams: (url, data, val) =>
    new Promise((resolve, reject) => {
      axiosInstance
        .get(`${apiUrl}/${url}/${data}/${val}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    }),
  validEmail: (URL, data) =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}`, {
          params: {
            email: data,
          },
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  validCompanyName: (URL, data) =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}/${data}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  GetReportTemplateSummary: (URL, data) =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}/${data}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  validdateEmail: (URL, data, custID) =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}`, {
          params: {
            email: data,
            customerId: custID,
          },
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  GetTemplateByReportId: (URL, reportId) =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}/${reportId}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  GetReportTemplates: URL =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  getAllReports: URL =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}`, {
          params: {
            top: 41,
            skip: 0,
            orderBy: 'reportDate desc',
            isActive: true,
          },
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  getEquipmentBySeverity: (URL, pkId) =>
    new Promise(resolve => {
      axiosInstance
        .get(`${apiUrl}/${URL}/${pkId}`, {
          headers: {
            'Content-Type': applicationJson,
          },
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          resolve(err.message);
        });
    }),
  downloadDataImportResults: async requestIds => {
    try {
      const response = await axiosInstance.post(
        `${apiUrl}/admin/download-data-import-results`,
        { requestIds },
        {
          headers: {
            Accept: 'application/zip, application/octet-stream',
            'Content-Type': applicationJson,
          },
          responseType: 'blob',
        },
      );

      const blob = new Blob([response.data], { type: 'application/zip' });
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = `data_import_results_${moment().format(
        'YYYYMMDD_HHmmss',
      )}.zip`;
      document.body.appendChild(link);
      // Click the link to trigger the download
      link.click();

      // Clean up
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
  },
};
